import axios from "axios";
import { BASE_URL } from "../../constant-value";
import api from "../../services/interceptor";
import * as actionType from "../action-type";

export const carReducer = async (cars, action) => {
  // const newState = [...state]
  // newState.push(action.payload)
  // return newState
  //return [...state, action.payload]

  switch (action.type) {
    case actionType.GET_ALL:
      action.payload = 
      await api
          .get(`/cars`)
          .then((response) => {
            return response.data;
          })
          .catch((reason) => {
            //console.log(reason);
            alert(reason);
            return reason;
          });
      // action.payload = 
      // await axios
      //   .get(`${BASE_URL}/cars`)
      //   .then((response) => {
      //     return response.data;
      //   })
      //   .catch((reason) => {
      //     //console.log(reason);
      //     alert(reason);
      //     return reason;
      //   });

        console.log(action.payload)
      //return action.payload;

    case actionType.NEW:
      return action.payload;
    case actionType.EDIT:
      return action.payload;

    case actionType.DELETE:
      api
        .delete(`/cars/${action.payload.id}`)
        .then((response) => {
          //setIsLoading(true);
        })
        .catch((reason) => {
          //setIsLoading(false);
        })
        .finally(() => {
          //setIsLoading(false);
        });
      // axios
      //   .delete(`${BASE_URL}/cars/${action.payload.id}`)
      //   .then((response) => {
      //     //setIsLoading(true);
      //   })
      //   .catch((reason) => {
      //     //setIsLoading(false);
      //   })
      //   .finally(() => {
      //     //setIsLoading(false);
      //   });

      return action.payload;

    default:
      return action.payload;
  }
};
